import { Outlet } from "react-router-dom";

const RetailDashboardLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default RetailDashboardLayout;
